<template>
  <div id="app">
    <div class="container">
      <Header></Header>
      <router-view />
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
@import './assets/scss/common.scss';
#app {
  background: linear-gradient(180deg, #e4e9fb, rgba(255,255,255,0) 50%, rgba(255,255,255,0));;
}

.container {
  margin: 0 auto;
  width: 1200px;
}
</style>
